module.exports = __webpack_public_path__ + "static/media/DG-1.a47cb8c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/services/DG-1.jpg
// module id = 96
// module chunks = 0